<template>

  <span style="cursor:pointer;" @click="openMyEventModal()" ><button class="btn btn-warning btn-sm" >상세</button></span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  v-if="active">
          <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">이벤트신청 상세</h5>
  </div>

  <div class="modal-body">
    <table class="table">
      <tbody>
        <tr>
          <th>구분</th>
          <td style="text-align:center;" v-if="Tsub.eventCd == 'summer2025'">
             2025 여름방학 어학연수
          </td>
          <th>신청일</th>
          <td style="text-align:center;">
              {{Tsub.datRecDate}}
          </td>
        </tr>
        <tr>
          <th>이름</th>
          <td style="text-align:center;">
            {{Tsub.username}}
          </td>
          <th>ID</th>
          <td style="text-align:center;">
              {{Tsub.name}}
          </td>
        </tr>
        <tr>
          <th>회원번호</th>
          <td style="text-align:center;">
              {{Tsub.id}}
          </td>
          <th>연락처</th>
          <td style="text-align:center;">
              {{Tsub.parentPhone}}
          </td>
        </tr>
        <tr>
          <th>학습목표</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.datPlan, Tsub.datPlan)"
                :class="{'hidtype-changed': changedData.datPlan}"
                @input="doChange('datPlan', $event.target.value)">
                <option value="1" v-show="false">1시간</option>
                <option value="2" v-show="false">2시간</option>
                <option value="3">3시간</option>
              </select>
              <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.datPlan"
                @click="delete changedData.datPlan"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
          <th>달성여부</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.bitComplete, Tsub.bitComplete)"
                :class="{'hidtype-changed': changedData.bitComplete}"
                @input="doChange('bitComplete', $event.target.value)">
                <option value="1">달성</option>
                <option value="0">미달성</option>
              </select>
              <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bitComplete"
                @click="delete changedData.bitComplete"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
        <tr>
          <th>국가번호</th>
          <td>
            <input class="hidtype" style="width:90%;" :value="changedData.datNation || Tsub.datNation"
              :class="{'hidtype-changed': changedData.datNation}"
              @input="doChange('datNation', $event.target.value)" placeholder="국가번호" />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.datNation"
              @click="delete changedData.datNation"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
          <th>방문점수</th>
          <td>
            <input class="hidtype" style="width:90%;" :value="changedData.datPoint || Tsub.datPoint"
              :class="{'hidtype-changed': changedData.datPoint}"
              @input="doChange('datPoint', $event.target.value)" placeholder="방문점수" />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.datPoint"
              @click="delete changedData.datPoint"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
<div class="flex_center">
    <button type="button" class="btn btn-danger" @click="doSend()">수정</button>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> Close</button>
  </div>
  </div></div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    "name": "MyEvent",
    components: {

    },
    methods: {
      nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      openMyEventModal() {
        this.active = true;
        this.modifyMode(this.MyEvent)
        //console.log(this.Tsub.bookclubs);
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          //console.log(modalDom);
          modal.show();

        });
      },
      doChange(name, value) {
        if (this.Tsub[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      modifyMode(record){
        this.creating = false;
        this.changedData = {};
        this.Tsub =  {
          "eventNo": record.eventNo,
          "name": record.name,
          "username": record.username,
          "id": record.id,
          "eventCd" : record.eventCd,
          "datRecDate" : record.datRecDate,
          "parentPhone": record.parentPhone,
          "bitComplete": record.bitComplete,
          "datPlan": record.datPlan,
          "datNation": record.datNation,
          "datPoint": record.datPoint,
        }
      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = this.changedData;

        var send = {
          method: this.creating ? "post" : "patch",
          url: '/students/eventList/' + this.Tsub.eventNo,
          data: data
        };
        
        if(!this.active){
            //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
            $.notify({
              // options
              message: '사용유무를 지정하셔야 합니다. '
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
            return;
        }
    
        if(Object.keys(this.changedData).length){
          axios(send).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '처리할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              //this.$refs.qg.search()
              this.$parent.search();
              (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
            }
          })

        }
      }
    },
    mounted() {
      this.Tsub = this.MyEvent;
      //console.log(this.Tsub.bookclubs);
    },
    watch: {
      sub(){
        alert('tsub has been updated')
              this.Tsub = this.MyEvent;
      }
    },
    props: {
      MyEvent: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
            creating: false,
            active: false,
            Tsub: {
              "eventNo": "",
              "name": "",
              "username": "",
              "id": "",
              "eventCd": "",
              "datRecDate": "",
              "parentPhone": "",
              "datPlan": "",
              "datNation": "",
              "datPoint": "",
              "bitComplete": ""
            },
            changedData: {
              "eventNo": "",
              // "name": "",
              // "username": "",
              // "id": "",
              // "eventCd": "",
              // "datRecDate": "",
              // "parentPhone": "",
              "datPlan": "",
              "datNation": "",
              "datPoint": "",
              "bitComplete": ""
            },
            product: null
        }
    }
}
</script>

<style>

</style>
